import { commonFilter } from './filter';

export default {
  pageName: 'Google Trends',
  pageId: '20101',
  pagePath: '/opinion/Trends',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
